import PropTypes from 'prop-types';
import WishCard from './WishCard';
import './WishPreviewModal.css';

/**
 * 點擊樹上已掛卡片的放大預覽 — 沿用結果 popup 的卡片放大樣式，但背景較輕量
 */
const WishPreviewModal = ({ wish, onClose }) => {
    return (
        <div
            className="wish-preview-backdrop fixed inset-0 z-500 flex items-center justify-center p-4"
            style={{ backgroundColor: 'rgba(0,0,0,0.45)' }}
            onClick={onClose}
        >
            <WishCard
                wish={wish}
                size="full"
                className="wish-preview-card shadow-2xl"
                style={{ width: 'min(80vw, 340px)' }}
                textScale={1.7}
            />
        </div>
    );
};

WishPreviewModal.propTypes = {
    wish: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default WishPreviewModal;
